import { defineMessages } from 'react-intl';

export default defineMessages({
  MyComplementaryHealthCoverageTitle: {
    id: 'asi.my_contracts_bloc.my_complementary_health_coverage_title',
  },
});
